import { useState, useMemo, useCallback } from 'react';
import { useDispatch } from "react-redux";
import SearchComponent from '../../components/CoreComponents/Search.tsx';
import roleCheck from "../../utils/roleCheck.ts";
import { ROLES } from "../../utils/roles.ts";
import { RootState } from "../../store/store.ts";
import { useSelector } from "react-redux";
import useModelInespections from '../../Helpers/CustomHooks/useModelInespections.tsx';
import usePagination from '../../Helpers/CustomHooks/usePagination.ts';
import { filteredInspections } from '../../Helpers/Functions.ts';
import PaginatedTable from '../../components/PaginatedTable/PaginatedTable.tsx';
import { setModal } from '../../store/Utilities';
import { AddModelForm } from '../../components/AddModelForm/AddModelForm.tsx';
import { IoMdAdd } from "react-icons/io";

export default function ModelInespections() {
    const { role: userRole } = useSelector((state: RootState) => state.SelectedUser.SelectedUser);
    const isAdminUser = roleCheck(userRole, [ROLES.SuperAdmin, ROLES.Admin]);
    const [searchTerm, setSearchTerm] = useState('');
    const dispatch = useDispatch();

    const handleAddModel = useCallback(() =>
        dispatch(setModal({
            Chilren: () => <AddModelForm />,
            open: true,
            hideModalFooter: true,
        })), []);

    const tableProps = useModelInespections();
    const filteredRows = useMemo(() => filteredInspections(searchTerm, tableProps?.rows),
        [tableProps?.rows, searchTerm]);
    const paginationProps = usePagination(filteredRows, 25);

    const handleSearch = (term: string) => {
        setSearchTerm(term);
        paginationProps?.setCurrentPage(1);
    };
    return (
        <div className="overflow-x-auto">
            <div className="flex justify-between items-center mb-4">
                {/* Search Component */}
                <div className="flex-grow mr-4">
                    <SearchComponent onSearch={handleSearch} />
                </div>
                {isAdminUser &&
                    <button
                        type="button"
                        className="bg-orange-1000 hover:bg-gray-800 float-right"
                        title="Add Model"
                        onClick={handleAddModel}>
                        <span className="flex items-center text-sm font-medium text-white">
                            <IoMdAdd size={18} />
                            <span className="ml-1">Add Model</span>
                        </span>
                    </button>
                }
            </div>
            {<PaginatedTable tableProps={tableProps} pagination={paginationProps} />}
        </div>
    );
}   